// extracted by mini-css-extract-plugin
module.exports = {"root":"TwoCollGrid-module--root--5KaK2","grid":"TwoCollGrid-module--grid--1rjFv","item":"TwoCollGrid-module--item--1_SmG"};